import React from "react";
import { Col, Form, Icon, Popover, Radio, Row, Switch, Upload } from "antd";
import { useFreire } from "../../../../../utils/freireContext";
import { useNewCampaignContext } from "../../context";
import * as texts from "../../../locales";
import MyDivider from "../../../../../components/MyDivider";
import cpfCsvExample from "../../../../../assets/cpf-coupon-autolink-example.png";
import emailCsvExample from "../../../../../assets/email-coupon-autolink-example.png";
import chassiCsvExample from "../../../../../assets/chassi-coupon-autolink-example.png";

const { Dragger } = Upload;

export const autoLinkCouponType = {
  EMAIL: "email",
  CHASSI: "chassi",
  FULL_REGISTER: "full_register",
  CPF: "cpf",
};

export const ELIGIBLE_USERS_TO_USE_COUPON_TYPE = {
  ANYONE: "ANYONE",
  ELIGIBLE_USERS: "ELIGIBLE_USERS",
};

export default function EligibleUsers({ showDivider = true, isFleet = false }) {
  const { freire } = useFreire();
  const { form } = useNewCampaignContext();
  const { getFieldDecorator, getFieldValue } = form as any;

  const isEligibleUsersRule =
    getFieldValue("eligibleUsersType") ===
    ELIGIBLE_USERS_TO_USE_COUPON_TYPE.ELIGIBLE_USERS;

  const requiredFieldRule = {
    required: true,
    message: freire(texts.REQUIRED_FIELD),
  };

  return (
    <>
      <span
        style={{
          color: "#fd5876",
          fontWeight: "bold",
          textTransform: "uppercase",
        }}
      >
        {freire(
          isFleet
            ? texts.ELIGIBLE_FLEET_DEFINITION
            : texts.ELIGIBLE_USERS_DEFINITION
        )}
      </span>
      <Row gutter={[8, 0]}>
        <Col span={16}>
          <Form.Item label={freire(texts.ELIGIBLE_USERS_TO_RECIEVE_COUPON)}>
            {getFieldDecorator("eligibleUsersType", {
              rules: [requiredFieldRule],
            })(
              <Radio.Group buttonStyle="solid" className="customRadioGroup">
                <Radio.Button value={"ANYONE"}>
                  {freire(texts.ANYONE_WHO_ADD_COUPON)}
                </Radio.Button>
                <Radio.Button value={"ELIGIBLE_USERS"}>
                  {freire(texts.SPECIFIC_USERS)}
                </Radio.Button>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
      </Row>
      {isEligibleUsersRule && (
        <>
          <Row gutter={[16, 0]}>
            <Col span={8}>
              <Form.Item label={freire(texts.SELECTED_FROM)}>
                {getFieldDecorator("autoLinkCouponType", {
                  initialValue: autoLinkCouponType.CHASSI,
                  ...(isEligibleUsersRule && { rules: [requiredFieldRule] }),
                })(
                  <Radio.Group
                    buttonStyle="solid"
                    className="customRadioGroup"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Radio value={autoLinkCouponType.CHASSI}>
                      {freire(texts.CHASSI)}
                      <Popover
                        placement="right"
                        trigger="hover"
                        content={
                          <img
                            src={chassiCsvExample}
                            style={{ maxWidth: "300px" }}
                            alt="info"
                          />
                        }
                      >
                        <span
                          style={{ textDecoration: "underline", marginLeft: 8 }}
                        >
                          {freire(texts.EXAMPLE)}
                        </span>
                      </Popover>
                    </Radio>
                    <Radio value={autoLinkCouponType.EMAIL}>
                      {freire(texts.EMAIL)}
                      <Popover
                        placement="right"
                        trigger="hover"
                        content={
                          <img
                            src={emailCsvExample}
                            style={{ maxWidth: "300px" }}
                            alt="info"
                          />
                        }
                      >
                        <span
                          style={{ textDecoration: "underline", marginLeft: 8 }}
                        >
                          {freire(texts.EXAMPLE)}
                        </span>
                      </Popover>
                    </Radio>
                    <Radio value={autoLinkCouponType.CPF}>
                      {freire(texts.CPF)}
                      <Popover
                        placement="right"
                        trigger="hover"
                        content={
                          <img
                            src={cpfCsvExample}
                            style={{ maxWidth: "300px" }}
                            alt="info"
                          />
                        }
                      >
                        <span
                          style={{ textDecoration: "underline", marginLeft: 8 }}
                        >
                          {freire(texts.EXAMPLE)}
                        </span>
                      </Popover>
                    </Radio>
                    {/* <Radio value={autoLinkCouponType.FULL_REGISTER}>
                      {freire(texts.FULL_REGISTER)}
                    </Radio> */}
                  </Radio.Group>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <Form.Item>
                {getFieldDecorator("couponsSheet", {
                  ...(isEligibleUsersRule && { rules: [requiredFieldRule] }),
                })(
                  <Dragger
                    name="file"
                    multiple={false}
                    beforeUpload={() => false}
                  >
                    <p className="ant-upload-text">
                      <Icon type="upload" />
                      {freire(texts.CLICK_OR_DRAG_HERE)}
                    </p>
                  </Dragger>
                )}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
      {!isFleet && (
        <Row>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelAlign="right"
              label={freire(texts.ONLY_USERS_WITHOUT_CHARGE)}
            >
              {getFieldDecorator("onlyUsersWithoutCharge", {
                initialValue: false,
                valuePropName: "checked",
              })(
                <Switch
                  checkedChildren={freire(texts.YES)}
                  unCheckedChildren={freire(texts.NO)}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      )}

      {showDivider && <MyDivider />}
    </>
  );
}
